<div class="chat-messages-list-container">
  <div class="spinner-container" *ngIf="loading">
    <mat-spinner diameter="70" class="custom-spinner"></mat-spinner>
  </div>

  <div class="chat-messages-list-content" *ngIf="!loading">
    <div class="searchbar-chat">
      <app-search-bar
        class="search-chat"
        actionText="Pesquisar"
        placeholder="{{ placeholder }}"
        (search)="filter($event)"
      ></app-search-bar>
      <button
        *ngIf="showOnlyUnreadMessages"
        mat-mini-fab
        color="primary"
        (click)="toggleUnreadFilter()"
        matTooltip="Ver todas as mensagens"
        matTooltipClass="chat-filter-tooltip"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
      <button
        *ngIf="!showOnlyUnreadMessages"
        mat-icon-button
        color="primary"
        (click)="toggleUnreadFilter()"
        matTooltip="Filtrar mensagens não lidas"
        matTooltipClass="chat-filter-tooltip"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>

    <div
      [ngClass]="
        isDirector
          ? 'messages-container'
          : 'messages-container messages-container-adapted'
      "
      *ngIf="chatMessages && chatMessages.length > 0"
    >
      <cdk-virtual-scroll-viewport itemSize="87">
        <!-- Archived card -->
        <app-chat-item-archive
          [chatMessages]="chatMessages"
          [showArchived]="showArchived"
          [showActiveTickets]="showActiveTickets"
          (showArchivedChange)="showArchivedRooms($event)"
        >
        </app-chat-item-archive>
        <!--   -->

        <!-- Active Tickets card -->
        <app-chat-item-active-ticket
          [chatMessages]="chatMessages"
          [showArchived]="showArchived"
          [showActiveTickets]="showActiveTickets"
          (showActiveTicketsChange)="showActiveTicketRooms($event)"
        >
        </app-chat-item-active-ticket>
        <!--   -->

        <div
          *cdkVirtualFor="let chat of chatMessages | arrayFilterCallback : filterChat : [showArchived, showActiveTickets, showOnlyUnreadMessages]"
          [className]="
            selectedItem == chat && clickedgroup
              ? 'messages-chats-list-group messages-chats-content'
              : 'messages-chats-content'
          "
        >
          <app-chat-item
            [chat]="chat"
            [selected]="selectedItem == chat"
            (selectEvent)="openDetails(chat)"
            (click)="handleSelectedChat($event)"
            (chatChange)="onChatChange($event)"
          ></app-chat-item>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <!-- TODO: Substituir por um componente -->
    <div class="no-chat-list-container" *ngIf="chatMessages.length === 0">
      <div class="no-chat-list-content">
        <img
          class="img-no-chat-list"
          src="../../../../../assets/images/no-chat.svg"
        />
        <div *ngIf="screenWidth < 800" class="text-no-chat-list">
          <h2 class="text-no-chat-list-title">Olá, {{ userName }}</h2>
          <p class="text-no-chat-list-article">
            Nenhuma conversa encontrada, vamos iniciar uma nova?
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
